import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import { SupportList } from './supportTicketsSlice';

import CardHeader from '../../components/CardHeader';
import TopBar from '../../components/TopBar';
import ItemShimmer from '../../components/Shimmer/itemShimmer';
import TableSection from '../manageAdminUser/components/Table';
import Pagination from '../../components/Pagination';
import Table from './Components/Table';
import GlobalContext from '../../components/Context/GlobalContext';
import { dataService } from '../../services/data.services';
import Button from '../../components/Button';

const SupportTickets = () => {

    const [isLoading, setLoading] = useState();

    const { setToastmessage,toastErrorMessage,setToastErrorMessage } = useContext(GlobalContext);
    const dispatch = useDispatch();
    // const navigate=useNavigate();
    const Category = useSelector(state => state.SupportList);
    const { List,loading,error,Categories} = Category;
    
    // const location = useLocation();
    // const [sideModelType, setSideModelType] = useState('');
    const [searchParams, setSearchParams] = useSearchParams({ page_number:  1 });
    // const [email, setemail] = useState('')
    // const [editValue, setEditValue] = useState({})
    // const [errorState, seterrorState] = useState({})
    // const [submitSelected, setSubmitSelected] = useState(false);
    // const store = JSON.parse(localStorage.getItem('Store'))
    // const [addLoading,setAddloading]=useState(false)
    // const [errorDescription,seterrorDescription] = useState('');
    const [exportLoading,setExportLoading] = useState(false)
    const initialState={
        "ticket_name": '',
        "ticket_email": '',
        "ticket_phonenumber": '',
        "ticket_subject": '',
        "description": "",
        "store_email_address": ""
    }
    const [state, setState] = useState(initialState);

    const handleLoadData = () => {
        // setLoading(true);
        // let params = null
        // params.page_number = 1
        // params.filter = true
        // params.status = true
        // setSearchParams({ ...params})
    }

    const GetList = useCallback(async () => {
        try {
            const params=Object.fromEntries(searchParams)


            dispatch(SupportList(searchParams))
        } catch (error) {
            handleLoadData()
            console.error(error);
        }
    }, [searchParams]);

    useEffect(() => {
        GetList();
    }, [GetList]);

    const handleOnClickPageNumber = (pageNum) => {
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    } 

    const handleExport = async () => {
        // let params = Object.fromEntries(searchParams);
        // delete params.page_number
        // const body = { ...params }
        // let url = ''
        // url = searchParams.get('sort')
        setExportLoading(true)
        const res = await dataService.GetAPI(`admin-users/export-ticket`);
        if (!res.error) {
            window.open(
                res.data.url,
                '_blank'
            );
            // window.location.href = res.data.url
            setExportLoading(false)
            setToastmessage('Supports list exported successfully')
        }
    }

    return (
        <>
            <CardHeader header={'Support'} noIcon>
                <div className="bg-[#f5f5f5] px-[16px] py-[12px] mt-[110px]">
                    <div className='h-customh10 bg-white rounded'>
                        <div id='support-top-bar' 
                            className="bg-white flex pt-8 pb-3 justify-between items-center pr-[66px] pl-4 rounded-t">
                            <h1 className="font-playfair text-xl text-[#4B4B4B] font-[500] pl-1">Supports List</h1>
                            <div className="flex justify-center items-center space-x-10">
                                <Button
                                    classKey={`px-4 py-[5px] font-[400] 
                                    text-[14px] border border-[#9E2064] text-primary rounded-[12px]`}
                                    text="Export"
                                    testId='export-btn'
                                    smallLoader={true}
                                    loading={exportLoading}
                                    color={`#9E2064`}
                                    disabled={exportLoading}
                                    type="button"
                                    handleClick={handleExport}
                                />
                            </div>
                        </div>
                        <div className='bg-white h-fit rounded-b'>
                            {(List.data?.length > 0 || List.data?.length == undefined) && <Table
                                loading={loading}
                                GetList={GetList}
                            />}
                            { List.data?.length === 0 && 
                            <div className='flex flex-col gap-7 justify-center items-center pt-[95px]'>
                                <img src={`assets/images/empty.png`} alt='Empty'/>
                                <div> No support tickets available yet </div>
                            </div>}
                            {!loading &&  List.data?.length > 0  && Math.ceil(List.total_count / 10) > 1 && <Pagination
                                selectedPageNumber={searchParams.get('page_number')}
                                handleOnClickPageNumber={handleOnClickPageNumber}
                                TotalCount={List.total_count}
                                totalPageNumber={Math.ceil(List.total_count / 10)} />}
                        </div>
                    </div>
                </div>
            </CardHeader>

        </>
    );
}

export default SupportTickets